module.exports = __webpack_public_path__ + "img/logo_navbar.d1d4ed5f.png";